import { Outlet } from "react-router-dom";

export const MainLayout = () => {
  return (
    <div className="w-full min-h-screen flex flex-col">
      <div className="flex-1 w-full flex flex-col md:flex-row">
        <div className="w-full md:w-[100vw] min-h-screen bg-secondary overflow-x-hidden">
          <Outlet />
        </div>
      </div>
    </div>
  );
};
